import http from '@/libs/AxiosPlugin'

const orderPlan = {
  list () {
    return http.get('/orderPlan/list')
  },

  close (id) {
    return http.post('/orderPlan/close', {id})
  }
}

export default orderPlan



// WEBPACK FOOTER //
// ./src/api/orderPlan.js